import { render, staticRenderFns } from "./JsBanner.vue?vue&type=template&id=63b79212&scoped=true&"
import script from "./JsBanner.vue?vue&type=script&lang=js&"
export * from "./JsBanner.vue?vue&type=script&lang=js&"
import style0 from "./JsBanner.vue?vue&type=style&index=0&id=63b79212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b79212",
  null
  
)

export default component.exports